import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=f3af3e32&"
import script from "./startPage.vue?vue&type=script&lang=js&"
export * from "./startPage.vue?vue&type=script&lang=js&"
import style0 from "./startPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports